<!-- @format -->

<template>
	<span class="ibps-actions">
		<template v-for="(button, index) in actions">
			<!--只显示图标-->
			<template v-if="type === 'icon'">
				<el-tooltip
					v-if="handleActionHidden(button.hidden)"
					:key="getKey(button) + index"
					:content="getLabel(button)"
					:disabled="handleActionDisabled(button.disabled)"
					placement="top"
				>
					<el-button
						:key="getKey(button) + index"
						:name="getKey(button)"
						:size="button.size"
						:type="getType(button)"
						:icon="getIcon(button)"
						:plain="getPlain(button)"
						:disabled="handleActionDisabled(button.disabled)"
						class="action-icon"
						@click="emitEventHandler('action-event', button, position, data, index)"
					/>
				</el-tooltip>
			</template>
			<!--链接-->
			<template v-else-if="type === 'link'">
				<pc-toolbar-link
					v-if="handleActionHidden(button.hidden)"
					:key="getKey(button) + index"
					:type="getType(button)"
					:icon="getIcon(button)"
					:underline="false"
					:disabled="handleActionDisabled(button.disabled)"
					class="platform-mr-10"
					@click="emitEventHandler('action-event', button, position, data, index)"
				>
					<span v-if="!button.isShowIcon">{{ getLabel(button) }}</span>
				</pc-toolbar-link>
				<!-- <el-divider v-if="index < noHiddenActions.length - 1" :key="index" direction="vertical" /> -->
			</template>
			<!--菜单-->
			<template v-else-if="type === 'menu'">
				<pc-toolbar-menu-item
					v-if="handleActionHidden(button.hidden)"
					:key="getKey(button) + index"
					:icon="getIcon(button)"
					type="menu"
					:disabled="handleActionDisabled(button.disabled)"
					@click-event="emitEventHandler('action-event', button, position, data, index)"
				>
					<span v-if="!button.isShowIcon">{{ getLabel(button) }}</span>
				</pc-toolbar-menu-item>
			</template>
			<template v-else>
				<!--下拉-->
				<template v-if="button.mode === 'dropdown'">
					<el-dropdown
						:key="getKey(button)"
						:hide-on-click="false"
						@command="
							(action) => {
								emitEventHandler('action-event', action, position, data, index);
							}
						"
					>
						<span v-if="button.buttonType === 'link'" class="el-dropdown-link">
							{{ getLabel(button)
							}}<i v-if="hasRighticon(button.rightIcon)" class="el-icon-arrow-down el-icon--right" />
						</span>
						<el-button v-else :type="getType(button)" :icon="getIcon(button)">
							{{ getLabel(button)
							}}<i v-if="hasRighticon(button.rightIcon)" class="el-icon-arrow-down el-icon--right" />
						</el-button>
						<el-dropdown-menu v-if="button.menus && button.menus.length > 0">
							<template #dropdown>
								<el-dropdown-item v-for="menu in button.menus" :key="menu.key" :command="menu" :icon="getIcon(menu)">{{
									getLabel(menu)
								}}</el-dropdown-item>
							</template>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
				<!--默认-->
				<template v-else>
					<el-button
						v-if="handleActionHidden(button.hidden)"
						:key="getKey(button) + index"
						:name="getKey(button)"
						:size="button.size || 'large'"
						:type="getType(button)"
						:icon="button.iconType !== 'park' || !button.iconType ? getIcon(button) : ''"
						:plain="getPlain(button)"
						:disabled="handleActionDisabled(button.disabled)"
						:autofocus="false"
						@click="emitEventHandler('action-event', button, position, data, index)"
					>
						{{ getLabel(button) }}
					</el-button>
				</template>
			</template>
		</template>
	</span>
</template>
<script>
	// import permission from '@/directives/permission/index.js' // 权限判断指令
	// import { hasPermission } from '@/mixins/permission' // 权限判断指令
	import pcToolbarMenuItem from './menu-item';
	import pcToolbarLink from './link';
	import { BUTTONS, getButtonIcon } from './utils';
	export default {
		// directives: { permission },
		components: {
			pcToolbarMenuItem,
			pcToolbarLink,
		},
		props: {
			type: {
				type: String,
				default: 'button',
			},
			actions: {
				type: Array,
				default: () => {
					return [];
				},
			},
			position: {
				type: String,
				default: 'toolbar',
			},
			showIcon: {
				type: Boolean,
				default: true,
			},
			data: Object,
			socpe: {
				type: Object,
				default() {
					// return this;
				},
			},
			/**
			 * 是否受权限控制
			 */
			accessControl: {
				type: Boolean,
				default: true,
			},
			/**
			 * 标识
			 */
			identity: {
				type: String,
			},
		},
		data() {
			return {
				buttonStatus: true,
				stopTime: null,
			};
		},
		computed: {
			noHiddenActions() {
				if (!this.actions) return [];
				const noHiddenActions = [];
				for (let i = 0; i < this.actions.length; i++) {
					if (this.handleActionHidden(this.actions[i].hidden)) {
						noHiddenActions.push(this.actions[i]);
					}
				}
				return noHiddenActions;
			},
		},
		beforeUnmount() {
			if (!this.stopTime) {
				this.stopTime = null;
			}
		},
		methods: {
			emitEventHandler(action) {
				if (this.buttonStatus) {
					this.buttonStatus = false;
					this.$emit(action, ...Array.from(arguments).slice(1));
				}
				this.setButton();
			},
			setButton() {
				// 添加一个定时器，点击之后延时500ms，防二次点击
				clearTimeout(this.stopTime);
				this.stopTime = setTimeout(() => {
					this.buttonStatus = true;
				}, 500);
			},
			/**
			 * 处理按钮隐藏，显示
			 */
			handleActionHidden(hidden = false) {
				let isHidden = !hidden;
				if (typeof hidden === 'boolean') {
					isHidden = !hidden;
				} else if (typeof hidden === 'function') {
					isHidden = !hidden.call(this.socpe, this.data);
				}
				return isHidden;
			},
			/**
			 * 处理按钮禁用，显示disabled 的方法
			 */
			handleActionDisabled(disabled = false) {
				if (typeof disabled === 'boolean') {
					return disabled;
				} else if (typeof disabled === 'function') {
					return disabled.call(this.socpe, this.data);
				}
				return Boolean(disabled);
			},
			getLabel({ label, code, key }) {
				if (label) return label;
				const codeType = code || key;
				// 原先： 国际化显示按钮名称
				// return this.$te('common.buttons.' + key) ? this.$t('common.buttons.' + key) : key
				// 备注：先用这个显示按钮名称
				return BUTTONS[codeType]['label'];
			},
			getIcon({ icon, code, key }) {
				if (!this.showIcon) return;
				if (icon) {
					return icon;
				}
				const codeType = code || key;
				return getButtonIcon(codeType);
			},
			getType({ type }) {
				return type;
			},
			getKey(button) {
				return button.code || button.key;
			},
			getPlain({ plain }) {
				if (plain) {
					return plain;
				}
				return;
			},
			// getPermission({ key, permission, accessControl }) {
			//   if (!this.accessControl || (accessControl !== undefined && accessControl === false) || !getButtonAccessControl(key)) {
			//     return
			//   }
			//   if (permission) {
			//     return permission
			//   }
			//   if (this.identity) {
			//     return this.identity + '_' + key
			//   }
			//   return
			// },
			// hasPermission(menu) {
			//   if (!this.accessControl) {
			//     return false
			//   }
			//   if (menu.accessControl !== undefined && menu.accessControl === false) {
			//     return false
			//   }
			//   const permission = hasPermission(this.identity + '_' + menu.key)
			//   return !permission
			// },
			hasRighticon(rightIcon) {
				if (rightIcon) {
					return true;
				}
				return true;
			},
		},
	};
</script>
